import { useHandlers } from '@sparklayer-io/spark-dash-pages/context/page-context';
import { Alert, Button, LearnMoreLink } from '@ui/themed';
import { t } from 'i18next';
import { I18N_PAGE } from '../constants';
import { useSalesAgentsUnavailable } from '../hooks/use-sales-agents-unavailable';

export function SalesAgentUpsellAlert() {
  const { navigationHandler } = useHandlers();
  const salesAgentsUnavailable = useSalesAgentsUnavailable();

  if (!salesAgentsUnavailable) {
    return null;
  }

  return (
    <Alert headingLevel="h3" title={t(`${I18N_PAGE}.sales_agent_upsell.title`)}>
      <div className="flex flex-col gap-2">
        <span>
          {t(`${I18N_PAGE}.sales_agent_upsell.description`)}{' '}
          <LearnMoreLink link="https://docs.sparklayer.io/sales-agent-ordering" />
        </span>
        <span className="flex justify-end">
          <Button variant="secondary" onClick={() => navigationHandler.navigate('/settings/plan')}>
            {t(`${I18N_PAGE}.sales_agent_upsell.upgrade`)}
          </Button>
        </span>
      </div>
    </Alert>
  );
}
